"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeModificationRequestItem = void 0;
// FIXME: fromJSON版があるので削除できる
const immutable_1 = require("immutable");
const ModificationRequest_1 = require("../entity/ModificationRequest");
const modificationRequestIssue_1 = require("./modificationRequestIssue");
const modificationRequestItemMetadata_1 = require("./modificationRequestItemMetadata");
const user_1 = require("./user");
const createSomeModificationRequestItem = ({ id = '789', type = ModificationRequest_1.ModificationRequestItemType[1], typeName = '制作指示の内容の通りに作られていない', body = 'Natto smells awful, but tastes terrific.', bucketId = '123', assetIds = immutable_1.List(['123', '456', '789']), metadata = modificationRequestItemMetadata_1.createSomeModificationRequestItemMetadata({ feild: 'duration', value: '00:15' }), issue = modificationRequestIssue_1.createSomeModificationRequestIssue(), sender = user_1.createSomeDirectorUser(), } = {}) => new ModificationRequest_1.ModificationRequestItem({
    id,
    type,
    typeName,
    body,
    bucketId,
    assetIds,
    metadata,
    issue,
    sender,
});
exports.createSomeModificationRequestItem = createSomeModificationRequestItem;
